import { IAddProductInput, IAddProductVariantInput } from "muminsmart-utils";

export function getVariantRowIssues(
  variant: IAddProductVariantInput | undefined,
): string[] {
  const issues: string[] = [];

  if (!variant?.sku?.trim()) {
    issues.push("Missing SKU");
  }

  if (!variant?.featuredImage) {
    issues.push("Missing featured image");
  }

  if (!variant?.additionalImages?.length) {
    issues.push("Missing additional images");
  }

  if (!variant?.price || variant.price <= 0) {
    issues.push("Invalid price");
  }

  if (!variant?.discountedPrice || variant.discountedPrice <= 0) {
    issues.push("Invalid discounted price");
  }

  return issues;
}

export function getVariantValidationStats(
  variants: IAddProductVariantInput[] | undefined,
) {
  const list = variants ?? [];

  return list.reduce(
    (stats, variant) => {
      const issues = getVariantRowIssues(variant);

      if (issues.some((issue) => issue.includes("SKU"))) {
        stats.missingSku += 1;
      }

      if (issues.some((issue) => issue.includes("featured image"))) {
        stats.missingFeaturedImage += 1;
      }

      if (issues.some((issue) => issue.includes("additional images"))) {
        stats.missingAdditionalImages += 1;
      }

      if (issues.length > 0) {
        stats.withIssues += 1;
      }

      return stats;
    },
    {
      total: list.length,
      missingSku: 0,
      missingFeaturedImage: 0,
      missingAdditionalImages: 0,
      withIssues: 0,
    },
  );
}

export type VariantValidationStats = ReturnType<typeof getVariantValidationStats>;

export type VariantList = IAddProductInput["variants"];
